import { useState } from "react";
import { Link } from "react-router-dom";
import { Footer, Logo } from "@/components/Brand";
import { COUNTRIES } from "@/lib/content";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Notify() {
  const [f, setF] = useState({ preferred_name: "", email: "", country: "", consent: false, website: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const r = await fetch(`${API}/api/notify`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(f) });
      const d = await r.json();
      if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Please check your details");
      setDone(d.country);
    } catch (e2) { setErr(e2.message); }
    setBusy(false);
  };
  return (
    <div className="min-h-[100dvh] flex flex-col bg-alabaster">
      <header className="bg-charcoal"><div className="mx-auto max-w-3xl px-5 sm:px-8 h-16 flex items-center">
        <a href="https://ahucoach.com" data-testid="notify-logo-link"><Logo variant="gold" className="h-7" /></a>
      </div></header>
      <main className="flex-1 w-full mx-auto max-w-xl px-5 sm:px-8 py-12 sm:py-16 fade-in" data-testid="notify-page">
        <p className="eyebrow mb-3">Outside New Zealand</p>
        <h1 className="text-3xl sm:text-4xl">Let me know when membership opens</h1>
        <p className="mt-3 text-ink-soft">AHU membership is open in New Zealand for now. Leave your details and we'll email you when it opens where you are.</p>
        {done ? (
          <div className="ahu-card mt-8 p-6 sm:p-8 fade-in" data-testid="notify-done">
            <p className="font-display text-xl text-charcoal">Thank you. We'll email you when membership opens in {done}.</p>
            <Link to="/start" className="btn-quiet mt-5" data-testid="notify-start-link">Your first Action Plan is free, wherever you are</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="ahu-card mt-8 p-6 sm:p-8 space-y-5" data-testid="notify-form">
            <label className="block"><span className="mb-1.5 block text-sm font-medium text-charcoal">Preferred name</span>
              <input className="field" required maxLength={60} value={f.preferred_name} onChange={set("preferred_name")} data-testid="notify-name-input" /></label>
            <label className="block"><span className="mb-1.5 block text-sm font-medium text-charcoal">Email</span>
              <input className="field" type="email" required value={f.email} onChange={set("email")} data-testid="notify-email-input" /></label>
            <label className="block"><span className="mb-1.5 block text-sm font-medium text-charcoal">Country</span>
              <select className="field appearance-none" required value={f.country} onChange={set("country")} data-testid="notify-country-select">
                <option value="" disabled>Choose</option>
                {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
              </select></label>
            <input type="text" name="website" tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")}
              className="absolute -left-[9999px] h-0 w-0 opacity-0" aria-hidden="true" />
            <label className="flex items-start gap-3 cursor-pointer">
              <input type="checkbox" required className="mt-1 h-4 w-4 accent-[#424741]" checked={f.consent} onChange={set("consent")} data-testid="notify-consent-checkbox" />
              <span className="text-[15px]">Email me when AHU membership opens in my country. I can unsubscribe any time.</span>
            </label>
            {err && <p className="text-sm text-warn" data-testid="notify-error">{err}</p>}
            <button className="btn-gold w-full sm:w-auto sm:min-w-[200px]" disabled={busy || !f.consent} data-testid="notify-submit-btn">{busy ? "Saving" : "Let me know"}</button>
          </form>
        )}
        <p className="mt-6 text-sm text-ink-soft">We'll only use your details to tell you when membership opens. See our{" "}
          <Link to="/privacy" className="underline underline-offset-4" data-testid="notify-privacy-link">Privacy Policy</Link>.</p>
      </main>
      <Footer />
    </div>
  );
}
